// Text formatting utility
export const formatText = (text, isWelcome = false) => {
  if (!text) return text;

  // Si es mensaje de bienvenida, formateo simple
  if (isWelcome) {
    text = text.replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>');
    text = text.replace(/^• (.*?)$/gm, '<span class="bullet-item">• $1 </span>');
    text = text.replace(/\n/g, '<br/>');
    return text;
  }

  // Paso 1: Convertir **texto** a negrita
  text = text.replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>');

  // Paso 2: Procesar referencias con enlaces [1][2] etc.
  text = text.replace(/\[(\d+)\]/g, (match, num) => {
    return `<span class="ref-number clickable-ref" data-ref="${num}">[${num}]</span>`;
  });

  // Paso 3: Identificar y formatear secciones principales
  text = text.replace(/^(RESUMEN:|NORMATIVAS APLICABLES:|CRITERIOS DE GRADUACIÓN:|PROCEDIMIENTO RECOMENDADO:|AGRAVANTES:|ATENUANTES:)/gm,
    '<div class="section-title">$1</div>');

  // Paso 4: Identificar subsecciones numeradas (1., 2., 3.) - INLINE
  text = text.replace(/^(\d+\.)\s*/gm, '<span class="subsection-number">$1 </span>');

  // Paso 5: Colorear jurisdicciones con TODAS las variaciones
  text = text.replace(/\[MUNICIPAL\]|\*\*MUNICIPAL\*\*|\bMUNICIPAL\b(?![^<]*>)/gi,
    '<span class="jurisdiction-municipal">MUNICIPAL</span>');
  text = text.replace(/\[ESTATAL\]|\*\*ESTATAL\*\*|\bESTATAL\b(?![^<]*>)/gi,
    '<span class="jurisdiction-estatal">ESTATAL</span>');
  text = text.replace(/\[AUTONÓMIC[OA]\]|\*\*AUTONÓMIC[OA]\*\*|\bAUTONÓMIC[OA]\b(?![^<]*>)/gi,
    '<span class="jurisdiction-autonomica">AUTONÓMICA</span>');
  text = text.replace(/\[JURISPRUDENCIA\]|\*\*JURISPRUDENCIA\*\*|\bJURISPRUDENCIA\b(?![^<]*>)/gi,
    '<span class="jurisdiction-jurisprudencia">JURISPRUDENCIA</span>');

  // Paso 6: Formatear criterios específicos (Mínimo:, Máximo:, etc.) ANTES de point-item
  text = text.replace(/^[-•]\s*(Mínimo|Máximo|Agravantes|Atenuantes):/gm,
    '<div class="criteria-subsection"><strong>• $1:</strong></div>');

  // Paso 7: Separar puntos individuales después de criterios (pero NO los criterios mismos)
  text = text.replace(/^[-•]\s*([^\n]+)(?!.*:)(?!.*Mínimo)(?!.*Máximo)(?!.*Agravantes)(?!.*Atenuantes)/gm, '<div class="point-item">$1</div>');

  // Paso 8: Formatear elementos de listas con título
  text = text.replace(/^[-•]\s*([^:]+:)/gm, '<div class="list-item-title">• $1</div>');

  // Paso 9: Espaciado estructurado
  // Doble salto = separación de sección
  text = text.replace(/\n\s*\n/g, '<div class="section-break"></div>');

  // Paso 10: Convertir saltos simples a <br/> pero NO después de divs
  text = text.replace(/\n(?!\s*<)/g, '<br/>');

  // Paso 11: Limpiar <br/> innecesarios después de elementos de bloque
  text = text.replace(/(<\/div>)<br\/>/g, '$1');
  text = text.replace(/(<div[^>]*>)<br\/>/g, '$1');

  // Paso 12: Limpiar exceso de breaks consecutivos
  text = text.replace(/(<br\/>){3,}/g, '<br/><br/>');

  return text;
};

// Welcome messages for different models
export const WELCOME_MESSAGES = {
  claude: `**¡Hola, soy tu asistente jurídico SentencIA!** 🚔

**¿En qué puedo ayudarte hoy?**`,

  gpt4: `**¡Hola, soy tu asistente jurídico SentencIA!** ⚡

**¿En qué puedo ayudarte hoy?**`
};
